/** @jsx h */
import { h } from 'preact'
import Arrow from './icons/Arrow'
import DocumentIcon from '../icons/DocumentIcon'
import PhotoIcon from '../icons/PhotoIcon'

const AttachmentLink = props => {
  const { typeLabel, attachmentType, mediaUrl } = props
  let typeLabelText = typeLabel
  if (typeLabelText) {
    typeLabelText = typeLabel.toLowerCase()
  }

  return (
    <a
      href={mediaUrl}
      target='_blank'
      rel='noopener noreferrer'
      class='ClaimEvidence-action'
    >
      <div class='ClaimEvidence-icon'>
        {attachmentType === 'image' ? <PhotoIcon /> : <DocumentIcon />}
      </div>
      <div class='ClaimEvidence-view'>View {typeLabel}</div>
      <Arrow />
    </a>
  )
}

AttachmentLink.defaultProps = {
  mediaUrl: '',
  typeLabel: ''
}

export default AttachmentLink
